<template>
  <div>
    <!-- Summary Section -->
    <div class="row mb-4">
      <!-- Total Staff Card -->
      <div class="col-6 col-md-4 col-xl-2 mb-3">
        <div class="card border-0 rounded-lg text-white h-100 summary-card" style="background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);">
          <div class="card-body p-3 d-flex flex-column justify-content-between">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-white-50 text-uppercase font-size-12 font-weight-bold">Total Staff</span>
              <i class="fe fe-users font-size-18 text-white-50"></i>
            </div>
            <h3 class="font-weight-bold text-white mb-0">{{ summary.total_staff }}</h3>
          </div>
        </div>
      </div>
      <!-- Present Card -->
      <div class="col-6 col-md-4 col-xl-2 mb-3">
        <div class="card border-0 rounded-lg text-white h-100 summary-card" style="background: linear-gradient(135deg, #10b981 0%, #059669 100%);">
          <div class="card-body p-3 d-flex flex-column justify-content-between">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-white-50 text-uppercase font-size-12 font-weight-bold">Present</span>
              <i class="fe fe-check-circle font-size-18 text-white-50"></i>
            </div>
            <h3 class="font-weight-bold text-white mb-0">{{ reactivePresentCount }}</h3>
          </div>
        </div>
      </div>
      <!-- Absent Card -->
      <div class="col-6 col-md-4 col-xl-2 mb-3">
        <div class="card border-0 rounded-lg text-white h-100 summary-card" style="background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);">
          <div class="card-body p-3 d-flex flex-column justify-content-between">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-white-50 text-uppercase font-size-12 font-weight-bold">Absent</span>
              <i class="fe fe-x-circle font-size-18 text-white-50"></i>
            </div>
            <h3 class="font-weight-bold text-white mb-0">{{ reactiveAbsentCount }}</h3>
          </div>
        </div>
      </div>
      <!-- Late Card -->
      <div class="col-6 col-md-4 col-xl-2 mb-3">
        <div class="card border-0 rounded-lg text-white h-100 summary-card" style="background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);">
          <div class="card-body p-3 d-flex flex-column justify-content-between">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-white-50 text-uppercase font-size-12 font-weight-bold">Late</span>
              <i class="fe fe-clock font-size-18 text-white-50"></i>
            </div>
            <h3 class="font-weight-bold text-white mb-0">{{ reactiveLateCount }}</h3>
          </div>
        </div>
      </div>
      <!-- Leave Card -->
      <div class="col-6 col-md-4 col-xl-2 mb-3">
        <div class="card border-0 rounded-lg text-white h-100 summary-card" style="background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);">
          <div class="card-body p-3 d-flex flex-column justify-content-between">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-white-50 text-uppercase font-size-12 font-weight-bold">Leave</span>
              <i class="fe fe-log-out font-size-18 text-white-50"></i>
            </div>
            <h3 class="font-weight-bold text-white mb-0">{{ reactiveLeaveCount }}</h3>
          </div>
        </div>
      </div>
      <!-- Half Day Card -->
      <div class="col-6 col-md-4 col-xl-2 mb-3">
        <div class="card border-0 rounded-lg text-white h-100 summary-card" style="background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);">
          <div class="card-body p-3 d-flex flex-column justify-content-between">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-white-50 text-uppercase font-size-12 font-weight-bold">Half Day</span>
              <i class="fe fe-pie-chart font-size-18 text-white-50"></i>
            </div>
            <h3 class="font-weight-bold text-white mb-0">{{ reactiveHalfDayCount }}</h3>
          </div>
        </div>
      </div>
      <!-- Substitute Card -->
      <div class="col-6 col-md-4 col-xl-2 mb-3">
        <div class="card border-0 rounded-lg text-white h-100 summary-card" style="background: linear-gradient(135deg, #db2777 0%, #9d174d 100%);">
          <div class="card-body p-3 d-flex flex-column justify-content-between">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-white-50 text-uppercase font-size-12 font-weight-bold">Substitute</span>
              <i class="fe fe-refresh-cw font-size-18 text-white-50"></i>
            </div>
            <h3 class="font-weight-bold text-white mb-0">{{ reactiveSubstituteCount }}</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Attendance Table Card -->
    <div class="card border-0 shadow-sm rounded-lg overflow-hidden">
      <div class="card-header bg-white py-3 border-0">
        <div class="row align-items-center justify-content-between">
          <!-- Left side: Date Picker and Info -->
          <div class="col-12 col-md-6 mb-3 mb-md-0 d-flex flex-wrap align-items-center">
            <div class="d-flex align-items-center mr-4">
              <span class="mr-2 font-weight-bold text-muted">Date:</span>
              <a-date-picker
                :value="localDate"
                @change="onDateChange"
                format="YYYY-MM-DD"
                style="width: 150px;"
                :allowClear="false"
                :disabled-date="disabledDate"
              />
            </div>
            <div class="d-flex align-items-center mt-2 mt-sm-0">
              <a-button
                type="dashed"
                size="small"
                icon="left"
                class="mr-1"
                @click="navigateDay(-1)"
              />
              <a-button
                type="dashed"
                size="small"
                icon="right"
                class="mr-3"
                :disabled="isTodayOrFuture"
                @click="navigateDay(1)"
              />
              <a-button
                type="link"
                size="small"
                class="p-0 font-weight-bold text-primary"
                @click="setToToday"
              >
                Today
              </a-button>
            </div>
          </div>

          <!-- Right side: Search and quick selection -->
          <div class="col-12 col-md-6 d-flex flex-wrap align-items-center justify-content-md-end">
            <a-input-search
              placeholder="Search by name or code..."
              v-model="searchQuery"
              style="width: 220px;"
              allow-clear
              class="mr-2"
            />
            <div class="btn-group btn-group-sm mt-2 mt-sm-0">
              <a-button type="default" size="small" @click="toggleAll(true)" class="mr-1">
                All Present
              </a-button>
              <a-button type="default" size="small" @click="toggleAll(false)">
                All Absent
              </a-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Table Body -->
      <div class="table-responsive">
        <table class="attendance-table table mb-0">
          <thead>
            <tr>
              <th style="width: 150px;">Staff Code</th>
              <th>Staff Name</th>
              <th class="text-center" style="width: 180px;">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="mr-2">Status</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in filteredAttendance" :key="index">
              <td class="font-weight-semibold text-muted">{{ data.staffid }}</td>
              <td class="font-weight-semibold">{{ data.staffname }}</td>
              <td class="text-center">
                <div class="d-flex align-items-center justify-content-center">
                  <a-select
                    v-model="staffStatusMap[data.staffcode]"
                    size="small"
                    style="width: 110px"
                    :class="'status-select-' + (staffStatusMap[data.staffcode] || 'AB').toLowerCase()"
                  >
                    <a-select-option value="P">
                      <span style="color: #52c41a; font-weight: 600;"> Present</span>
                    </a-select-option>
                    <a-select-option value="AB">
                      <span style="color: #f5222d; font-weight: 600;"> Absent</span>
                    </a-select-option>
                    <a-select-option value="LT">
                      <span style="color: #fa8c16; font-weight: 600;"> Late</span>
                    </a-select-option>
                    <a-select-option value="L">
                      <span style="color: #722ed1; font-weight: 600;"> Leave</span>
                    </a-select-option>
                    <a-select-option value="HD">
                      <span style="color: #13c2c2; font-weight: 600;"> Half Day</span>
                    </a-select-option>
                    <a-select-option value="S">
                      <span style="color: #eb2f96; font-weight: 600;"> Substitute</span>
                    </a-select-option>
                  </a-select>
                </div>
              </td>
            </tr>
            <tr v-if="filteredAttendance.length === 0">
              <td colspan="3" class="text-center py-5 text-muted">
                <i class="fe fe-info font-size-24 mb-2 d-block"></i>
                No staff found matching query or no data for this date.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer action button -->
      <div class="card-footer bg-white border-0 py-3 text-right">
        <a-button
          type="primary"
          :loading="updating"
          @click="handleClick"
          icon="save"
          style="border-radius: 6px; font-weight: 500;"
        >
          Update Attendance
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'singleUpdateElement',
  props: {
    attendancedata: { type: Array, required: true },
    date: { type: String, required: true },
    summary: { type: Object, required: true },
  },
  data: function() {
    return {
      allstaffs: [],
      staffStatusMap: {},
      searchQuery: '',
      updating: false,
    }
  },
  watch: {
    attendancedata: {
      handler(n) {
        if (!n) return
        this.allstaffs = n.map(e => e.staffcode)
        let map = {}
        n.forEach(e => {
          let st = e.status
          if (st === 1) st = 'P'
          if (st === 0) st = 'AB'
          if (!['P', 'AB', 'LT', 'L', 'HD', 'S'].includes(st)) st = 'AB'
          map[e.staffcode] = st
        })
        this.staffStatusMap = map
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    localDate() {
      return this.date ? moment(this.date, 'YYYY-MM-DD') : null
    },
    filteredAttendance() {
      if (!this.searchQuery) return this.attendancedata
      const query = this.searchQuery.toLowerCase().trim()
      return this.attendancedata.filter(e => {
        const name = e.staffname ? e.staffname.toLowerCase() : ''
        const code = e.staffid ? String(e.staffid).toLowerCase() : ''
        return name.includes(query) || code.includes(query)
      })
    },
    reactivePresentCount() {
      return Object.values(this.staffStatusMap).filter(v => v === 'P').length
    },
    reactiveAbsentCount() {
      return Object.values(this.staffStatusMap).filter(v => v === 'AB').length
    },
    reactiveLateCount() {
      return Object.values(this.staffStatusMap).filter(v => v === 'LT').length
    },
    reactiveLeaveCount() {
      return Object.values(this.staffStatusMap).filter(v => v === 'L').length
    },
    reactiveHalfDayCount() {
      return Object.values(this.staffStatusMap).filter(v => v === 'HD').length
    },
    reactiveSubstituteCount() {
      return Object.values(this.staffStatusMap).filter(v => v === 'S').length
    },
    isAllSelected() {
      if (this.filteredAttendance.length === 0) return false
      return this.filteredAttendance.every(e => this.staffStatusMap[e.staffcode] === 'P')
    },
    isTodayOrFuture() {
      return this.date ? moment(this.date, 'YYYY-MM-DD').isSameOrAfter(moment(), 'day') : false
    },
  },
  methods: {
    moment,
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    onDateChange(date) {
      if (date) {
        this.$emit('date-changed', date.format('YYYY-MM-DD'))
      }
    },
    navigateDay(direction) {
      if (this.date) {
        const newDateObj = moment(this.date, 'YYYY-MM-DD').add(direction, 'days')
        if (direction > 0 && newDateObj.isAfter(moment(), 'day')) {
          return
        }
        this.$emit('date-changed', newDateObj.format('YYYY-MM-DD'))
      }
    },
    setToToday() {
      this.$emit('date-changed', moment().format('YYYY-MM-DD'))
    },
    toggleAll(checked) {
      const val = checked ? 'P' : 'AB'
      this.filteredAttendance.forEach(e => {
        this.$set(this.staffStatusMap, e.staffcode, val)
      })
    },
    handleClick() {
      var ts = this.staffStatusMap
      var cdate = this.date
      let updatedata = this.allstaffs.map(function(e) {
        let stStr = ts[e] || 'AB'
        let stCode = 0
        switch (stStr) {
          case 'AB': stCode = 0; break
          case 'P': stCode = 1; break
          case 'LT': stCode = 2; break
          case 'L': stCode = 3; break
          case 'HD': stCode = 4; break
          case 'S': stCode = 5; break
        }
        return {
          staff_id: e,
          date: cdate,
          status: stCode,
        }
      })

      let readydata = { staff_attendances: updatedata }
      this.updating = true

      this.$http.post('/api/staff/attendance/manual/entry', readydata)
        .then((data) => {
          if (data.status === 200) {
            this.$notification.success({
              message: 'Success',
              description: 'Staff attendance has been successfully updated!',
            })
            this.$emit('attendance-updated')
          }
        })
        .catch((err) => {
          console.error(err)
          this.$notification.error({
            message: 'Error',
            description: 'Failed to update staff attendance.',
          })
        })
        .finally(() => {
          this.updating = false
        })
    },
  },
}
</script>

<style scoped>
.summary-card {
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.attendance-table {
  width: 100%;
  border-collapse: collapse;
}

.attendance-table th {
  background-color: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 12px 16px;
  border-bottom: 2px solid #e2e8f0;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.5px;
}

.attendance-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  vertical-align: middle;
}

.attendance-table tbody tr {
  transition: background-color 0.15s ease;
}

.attendance-table tbody tr:hover {
  background-color: #f8fafc;
}

.font-size-12 {
  font-size: 12px;
}

.font-size-18 {
  font-size: 18px;
}

.font-size-24 {
  font-size: 24px;
}

.rounded-lg {
  border-radius: 12px !important;
}

/* Status select color variants */
.status-select-p >>> .ant-select-selection {
  border-color: #52c41a;
  background-color: #f6ffed;
}
.status-select-p >>> .ant-select-selection-selected-value span {
  color: #52c41a;
}

.status-select-ab >>> .ant-select-selection {
  border-color: #f5222d;
  background-color: #fff1f0;
}
.status-select-ab >>> .ant-select-selection-selected-value span {
  color: #f5222d;
}

.status-select-lt >>> .ant-select-selection {
  border-color: #fa8c16;
  background-color: #fff7e6;
}
.status-select-lt >>> .ant-select-selection-selected-value span {
  color: #fa8c16;
}

.status-select-l >>> .ant-select-selection {
  border-color: #722ed1;
  background-color: #f9f0ff;
}
.status-select-l >>> .ant-select-selection-selected-value span {
  color: #722ed1;
}

.status-select-hd >>> .ant-select-selection {
  border-color: #13c2c2;
  background-color: #e6fffb;
}
.status-select-hd >>> .ant-select-selection-selected-value span {
  color: #13c2c2;
}

.status-select-s >>> .ant-select-selection {
  border-color: #eb2f96;
  background-color: #fff0f6;
}
.status-select-s >>> .ant-select-selection-selected-value span {
  color: #eb2f96;
}
</style>
